import React, {Component} from 'react';

import classes from './sizes.module.scss';

export default class Sizes extends Component{

	render(){
		const {window_width, window_height, onUpdateWidth, onUpdateHeight} = this.props;

		return (
			<div className="wincalc-sizes wincalc-widget">
				<div className="d-flex justify-content-between">
					<div className={classes['wincalc-size']}>
						<div className="wincalc-title">Ширина</div>
						<div className={classes['wincalc-control-wrapper']}>

							<input type="number"
								className={classes['form-control']}
								id="wincalc-size-x"
								value = {window_width}
								onChange={(e) => onUpdateWidth(Number(e.target.value))}
							/>

						</div>
					</div>
					<div className={classes['wincalc-size']}>
						<div className="wincalc-title">Высота</div>
						<div className={classes['wincalc-control-wrapper']}>

							<input type="number"
								className={classes['form-control']}
								id="wincalc-size-y"
								value = {window_height}
								onChange = {(e) => onUpdateHeight(Number(e.target.value))}
							/>

						</div>
					</div>
				</div>
			</div>
		)
	}
}

